export const MutationTypes = {
    SetRegionSoft: "region_soft_set",
    SetRegion: "region_set",
    SetAuthToken: "auth_set",
    ClearAuthToken: "auth_clear",
    AcknowledgeUpdateNotification: "ack_update",
    SetPageLoading: "page_loading",
    SetBaseUrl: "base_url"
};

export const Actions = {
    Init: "init",
    SetRegionSoft: "region_soft_set",
    SetRegion: "region_set",
    SetAuthToken: "auth_set",
    ClearAuthToken: "auth_clear",
    AcknowledgeUpdateNotification: "ack_update",
    StartPageLoad: "page_load_start",
    FinishPageLoad: "page_load_end",
};
